import React, { FC } from 'react';
import Icon from '@mui/icons-material/Stars';
import { Box } from '@mui/material';
import { FieldProps, useRecordContext } from 'react-admin';

interface OwnProps {
    size?: 'large' | 'small';
}

const StarRatingField: FC<FieldProps & OwnProps> = ({
    source = 'rating',
    size = 'small',
}) => {
    const record = useRecordContext();

    return record && record[source] ? (
        <Box
            component="span"
            sx={{
                opacity: 0.87,
                whiteSpace: 'nowrap',
                display: 'flex',
            }}
        >
            {Array(record[source])
                .fill(true)
                .map((_, i) => (
                    <Icon
                        key={i}
                        sx={size === 'large' ? { width: 20, height: 20 } : { width: 15, height: 15 }}
                    />
                ))}
        </Box>
    ) : <span>-</span>
};

export default StarRatingField;
